const IconHeartFavorites = (): JSX.Element => {
  return (
    <>
      <path
        d="M9.84094 1.84313C11.3909 0.139733 13.9237 -0.465408 16.1427 0.376341L16.4019 0.482192L16.4044 0.483452L16.6766 0.610725C18.0157 1.27743 19.0488 2.39885 19.475 3.85935C19.9303 5.42022 19.6498 7.21972 18.561 9.04605C17.0584 11.5706 14.6979 13.4478 10.4201 16.5905L9.86202 17L9.30396 16.5905C5.02292 13.4454 2.66986 11.5732 1.1246 9.05802L1.1215 9.05298L1.11778 9.04731C0.0272378 7.21844 -0.245524 5.4175 0.213093 3.85746C0.670353 2.30226 1.81353 1.13101 3.2719 0.484712L3.27562 0.482822L3.27996 0.480932C5.5709 -0.508163 8.24137 0.0856063 9.84094 1.84313Z"
        fill="currentColor"
      />
    </>
  );
};

export default IconHeartFavorites;
